module.exports = __webpack_public_path__ + "img/popup-top.39511a3.png";